<template>
  <div class="post type-post hentry">
    <h2>
      <router-link to="/2010/12/su-sv-kaledom/">Su Šv. Kalėdom!</router-link>
    </h2>
    <div class="comm_date">
      <span class="month">Gruodžio</span><span class="date_nr">24</span>
    </div>
    <div class="entry">
      <div>
        <img
          alt=""
          class="size-thumbnail wp-image-80 alignright"
          height="150"
          src="/assets/Bell-150x150.png"
          style="padding-top: 20px;"
          title="Bell"
          width="150"
        /><strong><em>Mielieji,</em></strong>
      </div>
      <p>
        Šilumos ir ramybės Jūsų namams, džiaugsmo širdims, meilės ir santarvės
        šeimoms, prasmingų darbų ir svaraus uždarbio, stiprybės nelengvoje
        kasdienybėje.&nbsp;Susėskime prie Kūčių stalo, trumpam pamirškime
        rūpesčius, nepriteklius ir negandas, nustumkime į giliausią kertę
        blogybes ir atidarykime duris Ateinančiam ir Nešančiam į mūsų namus
        Tikėjimą, Viltį ir Meilę.&nbsp;Būkime vieningesni, puoselėkime savo
        kraštą, kurkime geresnį gyvenimą ir tikėkime šviesesne ateitimi.
        <strong><em>Romaldas Petras Damušis</em></strong>
      </p>
    </div>
  </div>
</template>
